import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter } from '@angular/core';
import {Survey} from "../survey/survey";
import {Router} from "@angular/router";
import {CommonService} from "../common.service";
import {ApiService} from "../api.service";

declare var $ :any;
declare var Hammer:any;

@Component({
  selector: 'app-begin',
  templateUrl: './begin.component.html',
  styleUrls: ['./begin.component.css'],
})
export class BeginComponent implements OnInit, AfterViewInit {
  @Input() survey: Survey;
  @Input() learningPathId: any;
  @Input() userType: string;
  @Input() totalSeconds:number;
  @Output() onBegin = new EventEmitter<any>();
  @Output() onRestart = new EventEmitter<any>();
  @Output() onContinue = new EventEmitter<any>();

  startPosition:number;
  startbottomBtnWidth:number;
  finishedNumber: number;
  name: string;
  description: string;
  abilityBack: boolean;
  isOpenClass: number = 0;
  assetsRoute: string = "../../assets";
  //滑动对象
  hammertime:any;
  isShowBackBtn : boolean = true
  isHarmonyOS = false; //是否鸿蒙系统

  constructor(private router: Router,
                private commonService: CommonService,
                private apiService: ApiService) { }

  ngOnInit() {
    this.isHarmonyOS = this.commonService.isHarmonyOS();
    this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
    this.isOpenClass = Number(localStorage.getItem("openClass")) ? 1 : 0;
    this.isShowBackBtn = localStorage.getItem("source_env") == "LMS_SCORM" ? false : true;
    let _this = this;

    this.apiService.ajax({
      'type':'GET',
      'url': 'sr/exposeoutapi/getAbilityBack'
    }).subscribe(result=>{
      _this.abilityBack = result.data.abilityBack;
      console.log('this.abilityBack =' + result.data.abilityBack );
    });
      this.finishedNumber = this.survey.finished_number;

      this.name = this.survey.name;
      this.description = this.survey.description;

       if(this.survey.type!=1){
           this.commonService.initPage({
               backgroundColor: '#fff'
           });
       }else{
           this.commonService.initPage({
               backgroundColor: '#3f4c84'
           });
       }



      /*if(this.survey.type==1){
          let bgPic=document.getElementById("backgroundPicture");
          var randomNum=Math.random()*100;
          if(randomNum>=0&&randomNum<20){
              bgPic.style.backgroundImage='url("../../assets/picture/feature/bg5.svg")';
              bgPic.style.backgroundSize='60% 60%';
          }else if(randomNum>=20&&randomNum<40 ){
              bgPic.style.backgroundImage='url("../../assets/picture/feature/bg1.svg")';
              bgPic.style.backgroundSize='80% 100%';
          } else if(randomNum>=40&&randomNum<60 ){
              bgPic.style.backgroundImage='url("../../assets/picture/feature/bg2.svg")';
              bgPic.style.backgroundSize='70% 70%';
          } else if(randomNum>=60&&randomNum<80 ){
              bgPic.style.backgroundImage='url("../../assets/picture/feature/bg4.svg")';
              bgPic.style.backgroundSize='80% 80%';
          }else{
              bgPic.style.backgroundImage='url("../../assets/picture/feature/bg3.svg")';
              bgPic.style.backgroundSize='80% 80%';
          }
      }*/
  }

  restart() {
      this.onRestart.emit(true);
  }

  continue() {
    this.onContinue.emit(true);
  }

  ngAfterViewInit() {
          let that = this;
          setTimeout(()=>{
            this.hammertime = new Hammer(document.getElementById('wrap'));
            this.hammertime.get('swipe').set({ direction: Hammer.DIRECTION_ALL });
            this.hammertime.on('swipeup swipedown', function(ev){
              that.logEventType(ev,that);
            });
          },1000);






//        var circleBtn=document.getElementById('button_top');//圆形按钮
//        var bottomBtn=document.getElementById('button_bottom');//圆形按钮下面的长条带
//        var restartBtn=document.getElementById('restartBtn');
//        var continueBtn=document.getElementById('continueBtn');
//        var ifBool=false; //表示是否点击的状态；
//        var button=document.getElementById('button');
//
//        var remBase=document.documentElement.clientWidth/7.5;
//        var buttonWidth=4.72*remBase;
//        var bottomBtnmax=4.72*remBase;
//        var bottomBtnmin=1.1*remBase;
//        var _this=this;
//
//        circleBtn.addEventListener("touchstart", function(e) {
//            e.stopPropagation();
//            ifBool= true;
//            bottomBtn.style.transition="width 0s linear";
//            _this.startPosition=e.touches[0].pageX || e.touches[0].clientX;
//            _this.startbottomBtnWidth=bottomBtn.offsetWidth;
//
//        });
//        window.addEventListener("touchend",function (e) {
//            ifBool = false;
//             bottomBtn.style.transition="width 0.5s";
//
//             var nowbottomBtnWidth=bottomBtn.offsetWidth;
//             var total=buttonWidth*0.5//button_bottom的百分之50
//
//             if(nowbottomBtnWidth<total)
//             {
//             bottomBtn.style.width=bottomBtnmin+"px";
//             _this.onBegin.emit(true);
//             }
//             if(nowbottomBtnWidth>=total)
//             {
//              bottomBtn.style.width=bottomBtnmax+"px";
//             wenzi.style.opacity="1";
//             wenzi.style.transition="opacity 1s";
//             }
//
//        });
//
//
//
//
//        var wenzi=document.getElementById('wenzi');
//        window.addEventListener("touchmove",function (e) {
//            if(ifBool){
//                var x = e.touches[0].pageX || e.touches[0].clientX;//获取鼠标的x值
//                var move=x-_this.startPosition; //移动后的坐标
//                var bottomBtnWidth=_this.startbottomBtnWidth-move;//移动后的宽度
//                var wenziminWidth=2.1*remBase;//字淡出的最小距离
//               if(bottomBtnWidth<bottomBtnmin)
//               {
//               bottomBtnWidth=bottomBtnmin;
//
//               }
//               if(bottomBtnWidth>=bottomBtnmax)
//               {
//
//               bottomBtnWidth=bottomBtnmax;
//               }
//               if(move=wenziminWidth)
//               {
//                wenzi.style.opacity="0";
//                wenzi.style.transition="opacity 1s";
//               }
//
//
//
//               bottomBtn.style.width=bottomBtnWidth+"px";
//            }
//        });
//        bottomBtn.addEventListener("transitionend",function() {
//              bottomBtn.style.transition="width 0s linear";
//       });
          //获取元素的绝对位置
          /*function getPosition(node) {
              var left = node.offsetLeft;
              var top = node.offsetTop;
              var current = node.offsetParent;

              while(current != null) {
                  left += current.offsetLeft;
                  top += current.offsetTop;
                  current = current.offsetParent;
              }

              return {
                 "left": left,
                  "top": top
              };
          }*/

  }

  logEventType(ev,that){
    if(ev.type == "swipeup"){
      $('#wrap').css({
        'top': '-100%',
        'opacity':'0'
      });
      that.hammertime.get('swipe').set({  enable: false  });

      setTimeout(()=>{
        $('#wrap').hide();
        that.onBegin.emit(true);
      },300);
    }
  }

    begin() {
        this.onBegin.emit(true);
    }

    showTip2(){
        $("#shade2").fadeIn();
        $("#tip2").fadeIn();
        document.getElementById('shade2').ontouchmove = function(e){ e.preventDefault(); }
        document.getElementById('tip2').ontouchmove = function(e){ e.preventDefault(); }
        document.getElementById('tip2Text').ontouchmove = function(e){ e.preventDefault(); }
        document.getElementById('quitBtn').ontouchmove = function(e){ e.preventDefault(); }
        document.getElementById('beginBtn').ontouchmove = function(e){ e.preventDefault(); }
    }

    close() {
        let preUrl = this.commonService.getStorage('dnaReturnUrl');
        if(preUrl) {
          window.location.href = preUrl;
        } else {
          if(this.learningPathId=='not'){
            let projectId = localStorage.getItem("projectId")
            let link = ['learning-map'];
            if(projectId){
              link = ['learning-project', projectId]
            }
            this.router.navigate(link);
          }else{
            this.apiService.ajax({
              'type': 'get',
              'url':'/ddilearner/v1/getLearningPathMetaId/'+this.learningPathId
            }).subscribe(result=>{
              let link = ['learning-path',result.data];
              this.router.navigate(link);
            });
          }
        }

        this.commonService.removeStorage('dnaReturnUrl');
    }
}



// WEBPACK FOOTER //
// ./src/app/begin/begin.component.ts